'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import FormCall from '@components/form-call/FormCall';
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import ImgPlug from '@images/mobile_images_gen/other_images/image_6_plug.webp';
import Img1 from '@images/renders/other_images/image_6.webp';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './MainForm.module.scss';
function MainForm(t0) {
  const $ = _c(24);
  const {
    adaptiveType
  } = t0;
  const [toggle, setToggle] = useState(false);
  const svgRef = useRef(null);
  const {
    isMobile,
    isDesktop,
    isTablet
  } = adaptiveType;
  let t1;
  if ($[0] !== isDesktop || $[1] !== isMobile || $[2] !== isTablet) {
    t1 = () => {
      if (!svgRef) {
        return;
      }
      const element = svgRef.current;
      let st8 = null;
      setTimeout(() => {
        if (isDesktop) {
          st8 = ScrollTrigger.create({
            trigger: element,
            start: "top top",
            id: "trigger12",
            scroller: !isMobile ? "#smooth-wrapper" : "body",
            scrub: true,
            pin: false,
            onToggle: () => {
              setTimeout(() => {
                setToggle(_temp);
              }, 1000);
            }
          });
        } else {
          if (isMobile || isTablet) {
            st8 = ScrollTrigger.create({
              trigger: element,
              start: "top top+=500px",
              id: "trigger12",
              scroller: !isMobile ? "#smooth-wrapper" : "body",
              scrub: true,
              pin: false,
              onToggle: () => {
                setTimeout(() => {
                  setToggle(_temp2);
                }, 1000);
              }
            });
          }
        }
        ScrollTrigger.refresh();
        return () => {
          st8.kill();
        };
      }, 1000);
    };
    $[0] = isDesktop;
    $[1] = isMobile;
    $[2] = isTablet;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isMobile) {
    t2 = [svgRef, isMobile];
    $[4] = isMobile;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(_temp4, t3);
  let t4;
  if ($[7] !== isMobile || $[8] !== toggle) {
    t4 = !isMobile && <AnimateLines id="vector_6" className={styles.svgClass} toggle={toggle} />;
    $[7] = isMobile;
    $[8] = toggle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isMobile || $[11] !== toggle) {
    t5 = isMobile && <AnimateLines id="vector_4_mob" className={styles.svgClass} toggle={toggle} />;
    $[10] = isMobile;
    $[11] = toggle;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className={styles.tenthScreenSvg}>{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={styles.tenthScreenFormBox}><FormCall formNameProp="footerForm" testId="mainpageFormSend" /></div>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isMobile) {
    t8 = !isMobile && <div className={styles.tenthScreenImgBox}><ParallaxMedia src={Img1} name="image" className={styles.tenthScreenImg} imagePlug={ImgPlug} /></div>;
    $[17] = isMobile;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <div className={styles.tenthScreenWrapper}>{t7}{t8}</div>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t9) {
    t10 = <div data-scroll={true} ref={svgRef} className={styles.tenthScreenContainer}>{t6}{t9}</div>;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp4() {
  return _temp3;
}
function _temp3() {
  if (ScrollTrigger.getById("trigger12")) {
    ScrollTrigger.getById("trigger12").kill();
  }
}
function _temp2() {
  return true;
}
function _temp() {
  return true;
}
export default MainForm;